import React, { useState } from 'react';
import styles from './TabPanel.module.css';
import { Tab, TabBar } from './TabBar';

export interface PanelTab extends Tab {
  content: React.ReactNode;
}

interface TabPanelProps {
  tabs: PanelTab[];
  defaultTab?: string;
}

export const TabPanel: React.FC<TabPanelProps> = ({ tabs, defaultTab }) => {
  const [activeTab, setActiveTab] = useState(defaultTab || tabs[0]?.id);

  return (
    <div className={styles.tabPanel}>
      <TabBar tabs={tabs} selectedTab={activeTab} onSelectedTabChange={setActiveTab} />
      {tabs.map(tab => (
        <div key={tab.id} className={`${styles.tabContent} ${activeTab === tab.id ? styles.active : ''}`}>
          {tab.content}
        </div>
      ))}
    </div>
  );
};
